import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const TermGIT = () => {
  return (
    <Grid container>
      <Typography style={{ fontWeight: 'bold', fontSize: '14px' }}>
        GIT Operador Mayorista es una agencia de viajes, cuya plataforma
        tecnológica permite a una gran cantidad de prestadores de servicios
        turísticos (el/los {'"Proveedor/es"'}) ofrecer y comercializar sus
        servicios hacia los usuarios, quienes a su vez pueden procurar
        averiguaciones sobre vuelos, alojamientos, autos, cruceros, actividades
        y demás servicios turísticos (el/los {'"Servicio/s Turístico/s"'}),
        comparar y reservar dichas prestaciones en tiempo real, y adquirirlas
        por separado o combinadas, armando y gestionando su propio viaje, de
        conformidad con sus necesidades personales.
      </Typography>
      <Box>
        <ul>
          <li style={{ fontSize: '13px' }}>
            GIT Operador Mayorista no es el proveedor de los Servicios
            Turísticos y actúa en nombre y por cuenta de los Proveedores, por lo
            no está obligado -directa ni indirectamente- a la ejecución del
            Servicio Turístico. Cuando Usted contrata Servicios Turísticos a
            través de GIT Operador Mayorista, está celebrando un contrato
            directamente con el Proveedor que ofrece sus Servicios Turísticos a
            través de nuestra Plataforma. GIT Operador Mayorista actúa como
            intermediario entre Usted y los Proveedores de Servicios Turísticos,
            y actúa en nombre y representación del Proveedor.
          </li>
          <li style={{ fontSize: '13px' }}>
            Al contratar Servicios Turísticos a través de GIT Operador
            Mayorista, Usted garantiza que: (i) es mayor de edad; (ii) acepta
            expresamente la recepción de estos Términos y Condiciones como medio
            alternativo de comunicación al soporte físico; (iii) posee plena
            capacidad para celebrar contratos; (iv) solo utiliza la Plataforma
            de GIT Operador Mayorista para reservar o contratar Servicios
            Turísticos para Usted y/o para otra persona para quien Usted tenga
            autorización de actuar; (v) en caso de adquirir servicios con
            destino/escala Cuba, no es ciudadano ni residente Norteamericano, ni
            se encuentra sujeto a la jurisdicción de Estados Unidos; y (vi) toda
            la información que Usted brinda es verídica, exacta, actual y
            completa.
          </li>
          <li style={{ fontSize: '13px' }}>
            Estas condiciones son las de carácter general que se aplican a los
            servicios de intermediación que le presta GIT Operador Mayorista y
            bajo ningún aspecto reemplazan o modifican las limitaciones de
            responsabilidad legalmente establecidas, ni a las condiciones
            especiales que cada Proveedor Turístico ha definido para sus
            Servicios Turísticos. Antes de contratar, revise las condiciones
            particulares de cada Servicio Turístico y de cada Proveedor. GIT
            Operador Mayorista, no se hace responsable ni tiene injerencia en
            las condiciones particulares establecidas por cada Proveedor para la
            prestación de sus Servicios Turísticos.
          </li>
          <li style={{ fontSize: '13px' }}>
            GIT Operador Mayorista, deja constancia de que su actividad de
            intermediación en la comercialización de Servicios Turísticos no
            garantiza que el destino elegido no presente riesgos para la salud e
            integridad de las personas. GIT Operador Mayorista no es responsable
            ni directa ni indirectamente por los daños o pérdidas que de
            cualquier modo Usted o quienes viajen junto a Usted puedan sufrir
            antes, durante o como consecuencia del destino elegido. GIT Operador
            Mayorista no se responsabiliza por los hechos derivados de caso
            fortuito o fuerza mayor, incluyendo fenómenos climáticos, hechos de
            la naturaleza, conflictos gremiales, entre otros, que pudieran
            acontecer antes o durante el la prestación del Servicio Turístico, y
            que pudieran eventualmente demorar, interrumpir o impedir la
            ejecución del mismo.
          </li>
          <li style={{ fontSize: '13px' }}>
            Antes de confirmar su solicitud de compra haciendo click en el botón
            Comprar y previa aceptación de estas Condiciones Generales (la
            {'"Solicitud de Compra"'}), le aconsejamos que revise los términos y
            condiciones particulares aplicables al Servicio Turístico que desea
            contratar. Así evitará sorpresas y podrá disfrutar de su viaje como
            lo planeó. Las políticas de cada Servicio Turístico son establecidas
            por cada Proveedor sin injerencia de GIT Operador Mayorista. Se
            aclara especialmente que GIT Operador Mayorista no tiene injerencia
            alguna en el cobro de penalidades por parte de los Proveedores o
            diferencias de tarifa en el caso de ser aplicables, que dependerán
            de las políticas de cada Proveedor.
          </li>
          <li style={{ fontSize: '13px' }}>
            El solo uso de la Plataforma implica la aceptación de todas y cada
            una de las condiciones generales y particulares incluidas en estos
            términos y condiciones. Su lectura le permitirá ejercer en mejor
            forma sus derechos como consumidor. Le sugerimos imprimirlas y
            conservarlas, junto con el resto de la documentación de viaje.
            Recuerde tomar nota del número de Solicitud de Compra que aparecerá
            en la pantalla al confirmar su solicitud. Ese número identifica su
            transacción y será indispensable para realizar cualquier gestión a
            través de GIT Operador Mayorista.
          </li>
        </ul>
      </Box>
      <Box>
        <Typography style={{ fontSize: '13px' }}>
          Debido a la condición global generada por la pandemia de COVID-19 tus
          vuelos pueden sufrir cambios o cancelaciones por parte de la compañía
          aérea. Las frecuencias de cada ruta pueden variar en los próximos
          meses según la demanda. Queda asentado que los imprevistos que se
          puedan presentar no son por parte de la empresa GIT Operador Mayorista
          o GIT S.R.L y no se responsabilizan por los mismos sino que queda
          sujeto a condiciones y políticas de cada compañía aérea, puede que se
          apliquen diferencias de tarifas que estarán estipuladas según cada
          aerolínea. En caso que tu vuelo se modifique pondremos a tu alcance
          todas las opciones de la línea aérea y te brindaremos el mejor
          asesoramiento para tu viaje. SI USTED CONTRATA SERVICIOS TURíSTICOS A
          TRAVéS DE GIT Operador Mayorista, TENGA PRESENTE LA SIGUIENTE
          INFORMACIóN:
        </Typography>
        <ul>
          <li style={{ fontSize: '13px' }}>
            CÓMO FUNCIONA EL PROCESO DE RESERVA Y COMPRA? Cuando Usted envía una
            Solicitud de Compra a través de la Plataforma de GIT Operador
            Mayorista, Usted nos autoriza a gestionar su reserva y a cursar
            el/los respectivo/s cargo/s a su cuenta o tarjeta. Preste mucha
            atención a nuestras comunicaciones posteriores, donde le iremos
            informando sobre los avances y estado de su Solicitud de Compra. El
            buen término de la gestión de la reserva y/o la confirmación de la
            compra, dependen del pago íntegro y oportuno del precio y/o tarifa
            de todos los Servicios Turísticos. Mientras no se confirme el pago
            total de la reserva, la Solicitud de Compra quedará en suspenso y
            podría ser cancelada por el Proveedor. La confirmación definitiva de
            los Servicios Turísticos y precios respectivos se producirá con la
            emisión de el/los ticket/s electrónico/s o el envío del voucher – lo
            que aplique - y su facturación. Además, en las operaciones a crédito
            se deberán satisfacer los requisitos propios fijados por su banco
            emisor. La emisión del ticket electrónico o el voucher – lo que
            aplique - da fe de la aceptación de las condiciones del Proveedor y
            la celebración del contrato suscrito entre el Proveedor y la persona
            cuyo/s nombre/s aparece/n en dicho ticket electrónico y/o voucher.
            Si la Solicitud de Compra quedara sujeta a confirmación
            -circunstancia que le será informada en el primer correo electrónico
            que reciba- los valores pagados antes de la confirmación serán
            recibidos bajo concepto de reserva. Si finalmente su Solicitud de
            Compra fuera rechazada por cualquier motivo (por ejemplo, por saldo
            insuficiente en su tarjeta de crédito, por falta de disponibilidad,
            por variación en la tarifa, etc.), GIT Operador Mayorista procederá
            a informarle las opciones disponibles para el caso en que Ud. desee
            insistir en la compra o reserva o, a su requerimiento, le devolverá
            los importes abonados. Si con posterioridad al ingreso de su
            Solicitud de Compra no recibe un correo electrónico con la
            información de compra, revise la carpeta de Spam y/o ingrese a Mi
            Cuenta / Mi Reserva o Mis Viajes en la Plataforma con el número de
            Solicitud de Compra. Desde allí podrá realizar gestiones y, en caso
            de dudas adicionales, podrá contactarse a los teléfonos que figuran
            en la Plataforma.
          </li>
          <li style={{ fontSize: '13px' }}>
            QUÉ DATOS PERSONALES HAY QUE INGRESAR? Usted deberá completar todos
            los campos con datos exactos para poder realizar reservas válidas de
            Servicios Turísticos a través de GIT Operador Mayorista. Al ingresar
            sus datos personales en la Plataforma, Usted declara que dichos
            datos (los {'"Datos Personales"'}) son exactos, precisos y
            verdaderos, y asume el compromiso de actualizar dichos Datos
            Personales conforme resulte necesario. GIT Operador Mayorista no se
            responsabiliza por la certeza de los Datos Personales provistos por
            Usted. Usted garantiza y responde por la veracidad, exactitud,
            vigencia y autenticidad de los Datos Personales ingresados. Recuerde
            que todos sus datos deberán coincidir en forma exacta con la
            Documentación de Viaje según se define en el punto VI.
          </li>
          <li style={{ fontSize: '13px' }}>
            QUÉ DATOS DE CONTACTO SE NECESITAN?: Usted deberá ingresar una
            dirección de correo electrónico en apartado {'"Datos de Contacto"'}.
            Ese correo es nuestra vía de contacto con Usted. Revise que el
            correo electrónico proporcionado como punto de contacto sea correcto
            y manténgase atento a la información que se le enviará a dicho
            correo. Se considerará que Usted tomó conocimiento oportuno de la
            confirmación de su Solicitud de Compra o de algún inconveniente o
            variación a la misma con el envío de dicha información al correo
            electrónico proporcionado por Usted. Tenga presente que si el correo
            electrónico ingresado por Ud. contiene algún error no recibirá
            comunicaciones fundamentales para la gestión de su Solicitud de
            Compra.
          </li>
          <li style={{ fontSize: '13px' }}>
            QUÉ DATOS DE FACTURACIÓN SE NECESITAN?: Usted deberá ingresar sus
            datos fiscales exactos en el apartado {'"Datos de Facturación"'}{' '}
            para poder emitirle el correspondiente comprobante fiscal. Usted
            declara que dichos datos son exactos, precisos y verdaderos. GIT
            Operador Mayorista no será responsable por la emisión de documentos
            con información incorrecta proporcionada por Usted. Usted garantiza
            y responde por la veracidad, exactitud, vigencia y autenticidad de
            los datos fiscales ingresados.
          </li>
          <li style={{ fontSize: '13px' }}>
            QUÉ DOCUMENTACIÓN NECESITARÍA PARA VIAJAR?: Usted tiene el deber de
            informarse responsablemente sobre la documentación legal y/o
            migratoria y/o requisitos sanitarios que podría necesitar Usted o
            las personas que viajan junto a Usted para poder realizar su viaje
            conforme a lo planeado (la {'"Documentación de Viaje"'}). Verifique
            con tiempo las condiciones de ingreso al país de destino y/o
            tránsito, condiciones especiales de visas y/o pasaportes, licencias
            de conducir, vacunas, permiso para menores u otras exigencias de
            documentos, tanto para los países de destino, como los países en
            tránsito, aun cuando no sea necesario salir del aeropuerto. Si la
            requiere y no dispone de ella, haga los trámites necesarios para
            obtenerla con anticipación. Los requisitos podrían variar según el
            país de destino y/o tránsito y según su país de nacionalidad y/o
            residencia y/o de la documentación con la que Usted viaje. Recuerde
            que es su responsabilidad cumplir con todos los requisitos y/o
            documentación de entrada y/o tránsito que exijan las autoridades
            migratorias, aduaneras y/o sanitarias de el/los país/es de destino/s
            y/o tránsito. Le aconsejamos que antes de reservar y partir,
            consulte todos los requisitos necesarios con la Embajada o Consulado
            correspondiente. Para más información visite:
            http://travelcentre.iata.org/
          </li>
          <li style={{ fontSize: '13px' }}>
            Sin perjuicio de lo antedicho, le recordamos que: (i) los residentes
            argentinos podrán trasladarse con el DNI Digital (o Pasaporte) a
            países del Mercosur (Brasil, Bolivia, Paraguay, Uruguay y Venezuela)
            y Estados Asociados (Chile, Colombia, Ecuador y Perú). En caso de
            viajar a otros países es necesario contar con el Pasaporte y (ii)
            los residentes extranjeros pueden viajar a las naciones
            sudamericanas citadas con DNI digital o Pasaporte de su país.
            Verifique con antelación la fecha de vencimiento de la documentación
            y tenga en cuenta que, en algunos países, se exige que la fecha de
            expiración no sea anterior a los seis meses al arribo al territorio
            extranjero.
          </li>
          <li style={{ fontSize: '13px' }}>
            En el caso de viajar con menores de 18 años, además del documento de
            viaje habilitado (DNI Digital o Pasaporte), necesitan autorización
            de acuerdo a distintas consideraciones: (i) Si el menor viaja con
            ambos padres bastará con que acrediten el vínculo mediante Libreta
            Civil de Familia o Partida de Nacimiento o Certificado de Nacimiento
            (sin importar la fecha de su emisión) o DNI del menor, en donde
            consten los datos filiatorios de los padres, (ii) Si lo hace sólo
            con uno de sus padres, además de demostrar la relación parental con
            alguno de los documentos citados, deberá acompañar la autorización
            del padre/madre ausente y (iii) si es hijo de menores, necesitará la
            autorización de los padres y el permiso correspondiente de uno de
            sus abuelos. Sin perjuicio de ello, revise la Documentación de Viaje
            necesaria según el tipo de transporte, el Proveedor, y el origen y/o
            destino del transporte ya que los requisitos podrían variar según
            Usted viaje por mar, por tierra o por aire y según cada Proveedor.
            En el caso de que el/los menor/es no viaje/n acompañado/s de un
            mayor responsable por favor revise las políticas de menor no
            acompañado de cada Proveedor. Para más información visite
            www.migraciones.gov.ar.
          </li>
          <li style={{ fontSize: '13px' }}>
            QUÉ TENDRÉ QUE PAGAR? ¿CóMO FUNCIONAN LOS MEDIOS DE PAGO?: Cuando
            Usted reserva uno o más Servicios Turísticos a través de GIT
            Operador Mayorista, Usted debe abonar (i) el precio o tarifa fijada
            por el Proveedor, (ii) los impuestos, tasas y/o percepciones
            fiscales aplicables al Servicio Turístico y, en caso de
            corresponder, (iii) el cargo de gestión por el servicio de
            intermediación de GIT Operador Mayorista (el {'"Cargo de Gestión"'}
            ).
          </li>
          <li style={{ fontSize: '13px' }}>
            ¿TENDRé DERECHO A RETRACTO?: A excepción de los productos
            relacionados con transporte aéreo, usted podrá ejercer su derecho de
            retracto dentro los diez días computados a partir de la celebración
            del contrato. Para ejercer este derecho, Usted deberá notificar a
            GIT Operador Mayorista su decisión en tal sentido, por escrito o
            mediante medios electrónicos o similares. GIT Operador Mayorista
            realizará las gestiones de presentación y seguimiento de su
            solicitud frente al Proveedor del Servicio Turístico, y -en caso de
            haber sido abonado al Proveedor- será el Proveedor del Servicio
            quien deberá proceder a la devolución de su dinero, mediante un
            crédito o una reversión de cargo a su tarjeta de crédito. Si el pago
            hubiera sido efectuado mediante transferencia bancaria, GIT Operador
            Mayorista requerirá nuevamente sus datos para poder gestionar el
            reembolso por ese medio. Sobre este punto, le informamos que el art.
            1110 del Código Civil y Comercial de la Nación indica que. En los
            contratos celebrados fuera de los establecimientos comerciales y a
            distancia, el consumidor tiene el derecho irrenunciable de revocar
            la aceptación dentro de los diez días computados a partir de la
            celebración del contrato. Si la aceptación es posterior a la entrega
            del bien, el plazo debe comenzar a correr desde que esta última se
            produce. Si el plazo vence en día inhábil, se prorroga hasta el
            primer día hábil siguiente. Las cláusulas, pactos o cualquier
            modalidad aceptada por el consumidor durante este período que tenga
            por resultado la imposibilidad de ejercer el derecho de revocación
            se tienen por no escritos. (…) ARTICULO 1112.- Forma y plazo para
            notificar la revocación. La revocación debe ser notificada al
            proveedor por escrito o medios electrónicos o similares, o mediante
            la devolución de la cosa dentro del plazo de diez días computados
            conforme a lo previsto en el artículo 1110. Sin perjuicio de lo
            expuesto en el párrafo anterior, Usted debe tener presente que el
            transporte aerocomercial en Argentina se encuentra regido por un
            conjunto de normas, entre las que se encuentran el Convenio de
            Montreal (1999, Ley 26.451), el Código Aeronáutico, la Resolución
            1532/98 del Ministerio de Obras y Servicios Públicos y la normativa
            de la International Air Transport Association ({'"IATA"'}) (la
            {'"Normativa Aeronáutica"'}). Estas normas no contemplan el derecho
            de retracto y/o arrepentimiento de la compra, por lo que las líneas
            aéreas se encuentran facultadas para establecer libremente las
            condiciones de cancelación, lo cual acontece sin intervención de GIT
            Operador Mayorista.
          </li>
          <li style={{ fontSize: '13px' }}>
            UNA VEZ CONFIRMADA UNA SOLICITUD DE COMPRA ¿PUEDO CAMBIARLA O
            CANCELARLA? SI LO HAGO ¿TENGO COSTOS ASOCIADOS?: Si Usted solicita
            un cambio o cancelación fuera de los plazos y procedimientos
            explicados en el punto anterior, y la regulación específica de la
            tarifa por Usted seleccionada así lo permitiera, GIT Operador
            Mayorista realizará las gestiones de presentación y seguimiento de
            su solicitud pero, tanto los plazos de contestación como la decisión
            final, serán del Proveedor del Servicio Turístico. Tenga en cuenta
            que si la fecha de ejecución del servicio es próxima, GIT Operador
            Mayorista no puede garantizar que el Proveedor del Servicio
            Turístico emita una resolución de la cuestión. La forma de proceder
            y las condiciones especiales que rigen para casos de cambios o
            cancelaciones en una reserva confirmada por Usted, son determinadas
            por los Proveedores de los Servicios Turísticos, quienes podrán
            establecer multas o penalidades aplicables para los cambios
            solicitados. Estas condiciones están disponibles para su consulta en
            nuestra Plataforma. Revíselas antes de reservar y recuerde que hay
            Servicios Turísticos que, por disposición de los Proveedores, no
            admiten cambios y/o devoluciones, o los admiten con restricciones
            y/o con penalidades, - aún en casos de enfermedad, huelga, fenómenos
            climáticos, etc.-. Recuerde que cada Proveedor define sus
            penalidades sin intervención o injerencia de GIT Operador Mayorista.
          </li>
          <li style={{ fontSize: '13px' }}>
            Las gestiones en GIT Operador Mayorista se realizan on-line y en
            tiempo real. Cuando Ud. solicita un cambio, está cancelando una
            reserva confirmada y solicitando otra nueva que se regirá por las
            condiciones particulares aplicables al momento en el que Usted
            realiza el cambio, por lo cual, además de las penalidades
            aplicables, podría existir una diferencia de tarifa que consiste en
            el valor que resulte de la diferencia entre la tarifa originalmente
            abonada y la nueva tarifa según disponibilidad tarifaria al momento
            de efectuar el cambio (la {'"Diferencia de Tarifa"'}). Recuerde que
            las tarifas turísticas son dinámicas y dependen de variables como
            anticipación de compra, fechas de viaje, promociones estacionales y,
            en el caso de vuelos, también de las restricciones tarifarias (a
            mayores restricciones, mayor precio).
          </li>
          <li style={{ fontSize: '13px' }}>
            En el caso de devoluciones aprobadas por el Proveedor, éstas podrás
            ser efectuadas mediante un crédito o una reversión de cargo a la
            misma tarjeta con la cual se hizo la reserva, previa autorización
            del (la) titular de la tarjeta de crédito. Si el pago fue realizado
            en efectivo y/o transferencia bancaria, GIT Operador Mayorista le
            requerirá sus datos bancarios para realizar el reembolso mediante
            transferencia bancaria. Los plazos de reembolso y/o de la reversión
            de cargo dependerán de cada Proveedor (en los casos de compañías
            aéreas se estiman habitualmente de entre 30 y 120 días).
          </li>
          <li style={{ fontSize: '13px' }}>
            Cabe aclarar que los Proveedores no se encuentran obligados a
            exceptuar al pasajero de las condiciones del contrato, aún en casos
            acreditados de enfermedad o incapacidad física que les impida
            viajar; es decir que si la tarifa abonada prevé el cobro de
            penalidad para realizar modificaciones/devoluciones o no permite
            cambios y/o reintegro, el Proveedor puede cobrar esos cargos o negar
            la devolución del costo de la reserva.
          </li>
          <li style={{ fontSize: '13px' }}>
            El Cargo de Gestión cobrado por GIT Operador Mayorista es de
            carácter no reembolsable. En caso de cancelación de reservas
            confirmadas por cualquier motivo, dicho Cargo de Gestión no será
            reintegrado ya que corresponde a un servicio efectivamente prestado
            por GIT Operador Mayorista. Asimismo, en el supuesto de que Usted
            solicite el cambio o cancelación de un Servicio Turístico, GIT
            Operador Mayorista podrá cobrar un Cargo de Gestión adicional.
          </li>
          <li style={{ fontSize: '13px' }}>
            QUÉ PASA SI NO ME PRESENTO A UTILIZAR UNA RESERVA? Si Usted no se
            presenta a utilizar su reserva en la fecha y horarios indicados (o
            llega con atraso) se configura lo que en el mercado turístico se
            conoce como No Show y Usted no tendrá derecho a exigir la devolución
            total o parcial del importe abonado. Si no va a utilizar su reserva
            en todo o en parte o si va a llegar con retraso a utilizar su
            reserva, le recomendamos comunicarlo previamente a GIT Operador
            Mayorista para conocer las restricciones aplicables
          </li>
          <li style={{ fontSize: '13px' }}>
            Los cambios o cancelaciones de reservas efectuadas por nuestro
            intermedio, si bien son regidos por los Proveedores de los Servicios
            Turísticos, deben ser gestionados a través de GIT Operador
            Mayorista. En cualquiera de los casos anteriores, la línea aérea y/o
            el proveedor lo derivarán a nuestra empresa.
          </li>
        </ul>
      </Box>
      <Box>
        <Typography style={{ fontSize: '13px', marginBottom: '2vh' }}>
          Tenga muy presente que cada Proveedor tiene sus propias regulaciones
          para la provisión de sus Servicios Turísticos. Cuando revise las
          regulaciones, sin perjuicio de los demás temas de su interés, preste
          atención a los siguientes puntos:
        </Typography>
        <Typography
          style={{
            fontWeight: 'bold',
            fontSize: '13px',
            marginBottom: '2vh',
          }}
        >
          CAPíTULO 1 – VUELOS{' '}
        </Typography>
        <Typography style={{ fontSize: '13px', marginBottom: '2vh' }}>
          El transporte aéreo se encuentra regulado por la Normativa
          Aeronáutica. A su vez, cada compañía aérea (la {'"Compañía Aérea"'})
          establece sus propias regulaciones tarifarias para la comercialización
          de pasajes aéreos (el/los {'"Pasaje/s Aéreo/s"'}).
        </Typography>
        <ul>
          <li style={{ fontSize: '13px' }}>
            RESERVAS DE VUELOS, TARIFAS: GIT Operador Mayorista es una agencia
            acreditada por la IATA y se encuentra autorizada a comercializar
            Pasajes Aéreos en representación de las Compañías Aéreas miembro de
            la IATA y en cumplimiento de sus manuales de tarifas, condiciones de
            transporte de sus instrucciones escritas. Cuando Usted ingresa una
            Solicitud de Compra en la Plataforma y ésta es confirmada mediante
            la emisión de un e-ticket, se genera, automáticamente y sin
            intervención manual alguna, un registro (Electronic Ticket Record o
            ETR) en el sistema de la Compañía Aérea con los datos ingresados por
            Usted en la Plataforma. Cada Pasaje Aéreo se encuentra regulado por
            una serie de condiciones y restricciones determinadas por cada
            Compañía Aérea para cada tarifa en particular. De acuerdo al monto
            de la tarifa, se imponen ciertas limitaciones sobre la utilización
            del Pasaje Aéreo, por ejemplo: no reembolsable, no transferible,
            restricciones sobre cambios de ruta, imposición de estadías mínimas
            y máximas, restricciones a la devolución del importe abonado, etc.
            Las tarifas más económicas son las que mayores restricciones poseen.
            Tenga presente que GIT Operador Mayorista no se encuentra autorizado
            a variar ni modificar en ningún caso las regulaciones de los Pasajes
            Aéreos.
          </li>
          <li style={{ fontSize: '13px' }}>
            INFORMACIóN DE VUELOS: Toda la información exhibida en la Plataforma
            respecto a los Pasajes Aéreos ofrecidos (itinerarios, tarifas, etc.)
            es proporcionada y actualizada en línea y en tiempo real
            directamente por cada Compañía Aérea a través de un sistema global
            de reservas (Global Distribution System o GDS). Las Compañías
            Aéreas, a través de los GDSs, son responsables exclusivas de
            actualizar las tarifas, la disponibilidad y los otros datos que
            aparecen en la Plataforma. Por este motivo, en el período entre el
            ingreso de la Solicitud de Compra y la confirmación del pago o
            emisión del Pasaje Aéreo, las tarifas establecidas por la Compañía
            Aérea podrían variar según disponibilidad. Los precios definitivos
            quedarán fijados a partir del momento de la confirmación definitiva
            de la reserva que se produce con la emisión de el/los ticket/s
            electrónico/s y su facturación. GIT Operador Mayorista no fija
            tarifas aéreas ni tiene control sobre la disponibilidad de las
            mismas.
          </li>
          <li style={{ fontSize: '13px' }}>
            MODALIDADES DE PAGO: Si Usted paga con tarjeta de crédito, tanto la
            tarifa como los impuestos y tasas son cobrados directamente con el
            propio código de comercio de la Compañía Aérea sin que dichos
            valores ingresen a GIT Operador Mayorista. Si Usted paga mediante
            depósito o transferencia bancaria, GIT Operador Mayorista endosa a
            la Compañía Aérea los montos correspondientes a las tarifas. En
            todos los casos, GIT Operador Mayorista solo percibe el valor
            correspondiente al Cargo de Gestión.
          </li>
          <li style={{ fontSize: '13px' }}>
            REPROGRAMACIONES, DEMORAS Y/O CANCELACIONES DE VUELOS: Por razones
            ajenas a GIT Operador Mayorista, las Compañías Aéreas podrían
            modificar ciertas condiciones de los vuelos como horarios, fechas o
            itinerarios; podrían demorarlos y/o reprogramarlos y/o cancelarlos.
            El transportador está habilitado a realizar modificaciones en los
            vuelos programados, en tanto las comunique a esta autoridad
            aerocomercial conforme la regulación aplicable y GIT Operador
            Mayorista no tiene ninguna injerencia ni intervención en relación
            con las modificaciones que podrían sufrir los vuelos. De producirse
            alguna de estas variaciones antes de las 24 hrs. de salida del
            vuelo, por instrucciones del proveedor final, GIT Operador Mayorista
            le informará las alternativas disponibles y sólo procederá a
            confirmar las modificaciones con su expresa confirmación o
            aceptación previa. Cualquier reclamo, demanda o denuncia por la
            prestación del servicio escogido deberá ser dirigida a la Compañía
            Aérea. Recuerde que son las Compañías Aéreas las que prestan el
            servicio de transporte. Dentro de las 24 hrs. de la salida de su
            vuelo GIT Operador Mayorista no puede realizar gestiones sobre los
            Pasajes Aéreos.
          </li>
          <li style={{ fontSize: '13px' }}>
            RESENTACIóN EN EL AEROPUERTO: Usted deberá hacerse presente en las
            oficinas de despacho de la Compañía Aérea en el aeropuerto de
            partida el día previsto y a la hora indicada con la Documentación de
            Viaje. Para vuelos domésticos aconsejamos presentarse en el
            aeropuerto con 2 horas de anticipación y, para vuelos
            internacionales, la anticipación deberá ser de al menos 3 horas.
            Tenga presente que los horarios que se reflejan en su Pasaje Aéreo
            están expresados en hora local del país de escala y/o destino. Si
            Usted no se presenta a embarcar o llega con atraso a embarcar (No
            Show), la Compañía Aérea puede cancelar cualquier reserva para la
            continuación del viaje o el retorno y Usted no tendrá derecho a
            exigir la devolución total o parcial del importe abonado.
          </li>
          <li style={{ fontSize: '13px' }}>
            SOLICITUD DE CANCELACIóN O CAMBIOS DE FECHA O ITINERARIO: Destacamos
            que usualmente las Compañías Aéreas determinan que las tarifas más
            económicas sean aquellas que no permiten cambios, cancelaciones ni
            devoluciones, y aun cuando sí lo permitieran, dichos cambios o
            cancelaciones están sujetos a penalidades. En el caso en que -de
            acuerdo con la reglamentación dispuesta por la Compañía Aérea- la
            tarifa seleccionada por Usted sí permitiera cancelaciones, GIT
            Operador Mayorista realizará las gestiones de presentación y
            seguimiento de su solicitud de cancelación frente a la Compañía
            Aérea, y será ésta quien deberá proceder a la devolución, mediante
            un crédito o una reversión de cargo a su tarjeta de crédito. Si el
            pago hubiera sido efectuado mediante transferencia bancaria, GIT
            Operador Mayorista requerirá nuevamente sus datos para poder
            gestionar el reembolso por ese medio. Si lo que Usted solicita es un
            cambio de fecha o itinerario y la tarifa del Pasaje Aéreo adquirido
            permite cambios, la Compañía Aérea podrá establecer una penalidad a
            abonar y, además, al fijar una nueva fecha o elegir un nuevo
            itinerario, Usted deberá abonar la Diferencia de Tarifa aplicable al
            momento del cambio. Los cambios deberán realizarse en las mismas
            clases emitidas o bien en clases superiores. Aclaramos que no es
            posible realizar cambios por tarifas más económicas publicadas
            posteriormente a la emisión del Pasaje Aéreo adquirido. El pago de
            la penalidad y la Diferencia de Tarifa puede realizarse únicamente
            con tarjeta de crédito en 1 (UN) pago. Además, tanto en el caso de
            cambios como de cancelaciones, GIT Operador Mayorista podrá cobrar
            un Cargo de Gestión adicional.
          </li>
          <li style={{ fontSize: '13px' }}>
            CAMBIOS EN EL/LOS NOMBRE/S O CAMBIO DE PASAJERO: El Pasaje Aéreo
            emitido a nombre del pasajero es nominativo, personal e
            intransferible. Preste mucha atención al ingresar su/s nombre/s y
            apellido/s en el/los lugar/es indicado/s para ello y en un todo
            conforme con su Documentación de Viaje. Usted tiene disponible una
            casilla para el/los nombre/s y otro para el/los apellido/s y tiene
            posibilidad de revisar esta información previo a confirmar la
            Solicitud de Compra. Su/s Pasaje/s Aéreo/s se emitirá/n
            automáticamente con la información ingresada por Usted en la
            Plataforma sin intervención manual alguna de parte de GIT Operador
            Mayorista. Una vez emitido el/los Pasaje/s Aéreo/s y generado el
            registro de ticket electrónico, las Compañías Aéreas no admiten -o
            en ciertos casos los admiten con costos- cambios de nombres o
            apellidos en un Pasaje Aéreo, ni aún en casos de errores de tipeo en
            los nombres de los pasajeros y/o de nombres y apellidos invertidos.
            Si su Pasaje Aéreo contiene algún error, la Compañía Aérea podría no
            dejarlo embarcar. GIT Operador Mayorista no se hace responsable por
            errores y/o inconsistencias en los Datos Personales por Usted
            ingresados en la Plataforma.
          </li>
          <li style={{ fontSize: '13px' }}>
            MENORES NO ACOMPAñADOS: Se considerará {'"menor no acompañado"'} a
            aquel que viaje sin al menos uno de sus padres o tutores legales.
            Las Compañías Aéreas pueden ofrecer servicios de asistencia y
            acompañamiento (con costo) que, según el caso, podrán ser
            obligatorios u opcionales para aquellos menores que viajen sin
            acompañante. Sin embargo, GIT Operador Mayorista no ofrece este tipo
            de servicios y no podrá asegurar el efectivo embarque del menor en
            el caso de que la exigencia fuera obligatoria. Los menores de entre
            2 y 5 años, deberán viajar obligatoriamente acompañados por sus
            padres o responsables a cargo. Normalmente el servicio de
            {'"menor no acompañado"'} es obligatorio para niños de entre 5 y 11
            años y opcional para niños de entre 12 y 17 años. El servicio no
            está disponible para niños que requieran certificación médica para
            viajar y/o que no puedan alimentarse y/o que no sean capaces de
            cubrir sus necesidades básicas de higiene y no está disponible para
            itinerarios con escalas o cambios de avión. Consulte la política
            específica de la Compañía Aérea por la que desee viajar.
          </li>
          <li style={{ fontSize: '13px' }}>
            EQUIPAJE: Todas las Compañías Aéreas tienen diferentes políticas de
            franquicia de equipaje. Lo usual en los vuelos de cabotaje es de 15
            kg y en los internacionales de 20/30 kg según la empresa y la clase
            en que se viaje. Infórmese antes de viajar. GIT Operador Mayorista
            no se responsabiliza por robo y/o hurto y/o pérdida de equipaje y
            demás efectos personales de los pasajeros. En caso de pérdida o
            deterioro de equipaje, Usted debe dirigirse a las oficinas de
            atención al cliente de la Compañía Aérea y realizar el
            correspondiente reclamo. Le aconsejamos contratar un seguro de viaje
            para cubrir parte de estos riesgos, el cual podrá ser adquirido
            mediante GIT Operador Mayorista. Absténgase de llevar en el equipaje
            elementos no permitidos, como corto punzantes, envases o recipientes
            que contengan más de 100 ml (líquidos, geles o aerosoles),
            exceptuando medicamentos que contentan prescripción médica.
          </li>
          <li style={{ fontSize: '13px' }}>
            SALUD Y APTITUD PARA EL VIAJE - EMBARAZADAS: Si Usted presenta
            alguna condición de salud particular, la aerolínea le exigirá una
            constancia de apto médico que le permita realizar el viaje. La misma
            debe tener una fecha de emisión no superior a 12 horas a la salida
            del vuelo. Tenga presente que no podrán viajar solos -ni con
            servicio de acompañante- personas que no puedan valerse por sí solas
            y/o no estén en capacidad de seguir instrucciones
          </li>
          <li style={{ fontSize: '13px' }}>
            VALIDEZ DEL PASAJE AéREO: De acuerdo con la Normativa Aeronáutica,
            los Pasajes Aéreos son válidos por un año desde la fecha de emisión.
            Cualquier excepción al plazo de validez debe ser solicitada a y
            autorizada por la Compañía Aérea. GIT Operador Mayorista no puede
            extender la validez de un Pasaje Aéreo bajo ninguna circunstancia
          </li>
          <li style={{ fontSize: '13px' }}>
            PASAJES {'"SOLO IDA"'}: Por disposiciones migratorias de cada país,
            en caso de ser no residente del país de destino y contratar por
            nuestro intermedio un Pasaje Aéreo únicamente de ida, Usted podrá
            ser requerido por las autoridades migratorias a justificar las
            razones por las que no cuenta con un Pasaje Aéreo de regreso. Le
            sugerimos consultar al Consulado o Embajada correspondiente antes de
            efectuar la reserva. Las Compañías Aéreas también podrán exigir esta
            documentación antes de embarcar.
          </li>
          <li style={{ fontSize: '13px' }}>
            STOP OVER: Por lo general las tarifas económicas no permiten Stop
            Over; se recomienda consultar qué tarifas lo permiten.
          </li>
          <li style={{ fontSize: '13px' }}>
            VUELOS O AEROLíNEAS LOW-COST: Tenga presente que cuando reserva un
            vuelo de una aerolínea {'"low cost"'}, la tarifa publicada no
            permite cambios ni cancelaciones, no incluye reserva de asiento, ni
            equipaje facturado (solo equipaje de mano), ni servicios
            complementarios tales como refrigerios y/o comidas y/o
            entretenimiento a bordo. Todos estos servicios se consideran
            adicionales y se ofrecen bajo diferentes condiciones según cada
            Compañía Aérea y a un costo diferencial. Tenga en cuenta que las
            compañías low-cost suelen operar en aeropuertos pequeños, regionales
            y/o secundarios. Antes de confirmar su Solicitud de Compra, revise
            atentamente las condiciones y tarifas que son informadas para cada
            caso ya que algunos de los servicios adicionales deben ser
            reservados y abonados con anticipación mientras que otros pueden ser
            adquiridos durante el vuelo.
          </li>
          <li style={{ fontSize: '13px' }}>
            REGULACIóN Y RESPONSABILIDAD EN EL TRANSPORTE AéREO: La
            responsabilidad de las Compañías Aéreas por el transporte de las
            personas y sus equipajes se encuentra regulada por la Normativa
            Aeronáutica. Si Usted desea realizar un reclamo respecto del
            contrato de transporte aéreo celebrado entre Usted y una Compañía
            Aérea, Usted puede efectuarlo ante la Administración Nacional de
            Aviación Civil (http://www.anac.gov.ar/), organismo encargado de
            regular, fiscalizar y certificar la actividad aeronáutica comercial
            en Argentina.
          </li>
        </ul>
      </Box>
      <Box>
        <Typography style={{ fontSize: '13px', marginBottom: '2vh' }}>
          Tenga muy presente que cada Proveedor tiene sus propias regulaciones
          para la provisión de sus Servicios Turísticos. Cuando revise las
          regulaciones, sin perjuicio de los demás temas de su interés, preste
          atención a los siguientes puntos:
        </Typography>
        <Typography
          style={{
            fontWeight: 'bold',
            fontSize: '13px',
            marginBottom: '2vh',
          }}
        >
          CAPíTULO 2 – ALOJAMIENTOS{' '}
        </Typography>
        <Typography style={{ fontSize: '13px', marginBottom: '2vh' }}>
          Cada hotel, hospedaje y/o departamento (el “Alojamiento”) tiene sus
          propias regulaciones del servicio y tarifarias.
        </Typography>
        <ul>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            RESERVA DE ALOJAMIENTO, TARIFAS
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              Muchos Alojamientos ofrecen, para la misma habitación, una “tarifa
              reembolsable” o una “tarifa no reembolsable” (más económica). Si
              reserva una tarifa “no reembolsable” el Alojamiento podrá cobrar
              el 100% de la estadía al finalizar la compra sin derecho a
              reembolso alguno aún en casos de que los impedimentos para
              utilizar el hospedaje se deban a razones de fuerza mayor. Si Usted
              tiene dudas acerca de la posibilidad de utilizar el hospedaje, le
              recomendamos reservar una “tarifa reembolsable”. Las penalidades
              que eventualmente se informen son cobradas por el Alojamiento. GIT
              S.R.L. no cobra penalidades ni Cargos de Gestión adicionales por
              cambios y/o cancelaciones
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            RESERVA DE ALOJAMIENTO, TARIFAS
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              La información específica del Alojamiento como nombre, ubicación,
              categorización, horarios de check-in y check-out, y servicios
              incluidos se encuentra suficientemente detallada en la Plataforma.
              Le aclaramos que toda la información exhibida en la Plataforma es
              proporcionada y actualizada en línea directamente por cada
              Alojamiento. Ellos son responsables exclusivos de actualizar las
              tarifas, la disponibilidad y los otros datos que aparecen en la
              Plataforma. Revise los comentarios de otros pasajeros para
              verificar que el Alojamiento se ajusta a sus preferencias y
              necesidades. GIT S.R.L. no es ni debe ser interpretado como un
              promotor de la calidad, el nivel de servicio y/o la calificación o
              clasificación de cualquier Alojamiento 0.3.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            MODALIDADES DE PAGO
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              GIT S.R.L. le ofrece distintas modalidades para poder efectuar y
              abonar sus reservas de Alojamientos. GIT S.R.L., en cada caso, le
              indicará las opciones de pago disponibles según el Alojamiento
              seleccionado.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            PRE PAGO
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              Bajo esta modalidad, Usted acepta que GIT S.R.L. cargue a su
              tarjeta de crédito el precio total de la reserva, que incluye
              impuestos, tasas, percepciones fiscales y/o el Cargo de Gestión.
              SU RESUMEN DE TARJETA DE CREDITO LLEGARA CON LOS VALORES ACEPTADOS
              DE COMPRA Y CARGOS DE GESTION A NOMBRE DE, GIT S.R.L.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            CANCELACIÓN O EXCESO DE RESERVAS DEL ALOJAMIENTO
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              GIT S.R.L. ofrece los Alojamientos en su Plataforma según la
              disponibilidad informada por los Proveedores a través de un
              sistema informático de reservas. En ningún caso GIT S.R.L.
              ofrecerá un Alojamiento que no otorgue disponibilidad en el
              sistema. Sin perjuicio de ello, tenga presente que el overbooking
              es una práctica habitual en el mercado turístico y, en algunos
              países, esta práctica se encuentra regulada. El overbooking puede
              suceder también por fallos en los sistemas de reservas o fallos
              humanos. En el caso de que un Alojamiento no pueda respetar su
              reserva en las condiciones contratadas, el Alojamiento deberá
              proporcionarle, a su costo, un alojamiento/habitación alternativa
              de calidad igual o superior a la reservada por Usted
              originalmente. GIT S.R.L., en su carácter de intermediario, hará
              sus mejores esfuerzos para que Usted pueda disfrutar de su estadía
              sin inconvenientes.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            PRESENTACIÓN EN EL ALOJAMIENTO
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              Recuerde que, si Usted no se presenta en el Alojamiento en la
              fecha y horario correspondientes, el Alojamiento podrá cancelar su
              reserva y considerarla como NO SHOW en cuyo caso Usted no tendrá
              derecho a exigir el reembolso total o parcial del importe abonado.
              Si por alguna circunstancia Usted va a llegar fuera de los
              horarios indicados, comuníquese previamente con el Alojamiento y/o
              con GIT S.R.L.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            SOLICITUD DE CANCELACIÓN O CAMBIOS
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              La posibilidad de efectuar cambios y/o cancelaciones y, en su
              caso, las penalidades aplicables a cada circunstancia están
              sujetos a las políticas del Alojamiento que son informadas en la
              Plataforma y en el Voucher. GIT S.R.L. no fija ni cobra
              penalidades por cambios y/o cancelaciones. Cualquier excepción a
              dichas condiciones deberá ser autorizada por el Alojamiento.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            MENORES
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              Si viaja con menores tiene que incluirlo en la reserva, aun cuando
              no ocupen cama. Recuerde que hay Alojamientos que no aceptan
              menores.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            EQUIPAJE – DEPÓSITO DE BIENES DE VALOR
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              Si Usted lleva consigo efectos de valor superior al que
              ordinariamente llevan los pasajeros, debe hacerlo saber al
              Alojamiento y guardarlos en las cajas de seguridad que se
              encuentren a disposición en el Alojamiento. La responsabilidad del
              Alojamiento se limita al valor declarado de los efectos
              depositados. Tenga en cuenta que, si sus efectos son excesivamente
              valiosos en relación con la importancia del Alojamiento, o los
              mismos causaran molestias al Alojamiento, éste podrá negarse a
              recibirlos.
            </Typography>
          </li>
          <li style={{ fontSize: '13px', paddingTop: '10px' }}>
            HORARIOS DE CHECK-IN Y CHECK-OUT
            <Typography style={{ fontSize: '13px', paddingTop: '10px' }}>
              Sin perjuicio de los horarios de check-in y check-out particulares
              informados para cada Alojamiento en la Plataforma, la cantidad
              prevista de días de alojamiento se computa desde el horario de
              check-in y finaliza en el horario de check-out del día siguiente,
              independientemente de la hora de llegada y/o de salida, y de la
              utilización completa o fraccionada del mismo. Tenga presente que
              los horarios que se reflejan en el voucher están expresados en
              horario local del lugar de destino.
            </Typography>
          </li>
        </ul>
      </Box>
    </Grid>
  );
};

export default TermGIT;
